<template>
  <!--begin::Card-->
  <v-app>
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">
          اطلاعات حساب شخصی
        </h3>
        <span class="text-muted font-weight-bold font-size-sm mt-1"
        >اطلاعات شخصی خود را به روز کنید.</span
        >
      </div>
      <div class="card-toolbar">
        <v-btn outlined class="btn btn-cancel" @click="cancel()">
          <img src="media/svg/icons/Code/Error-circle.svg" alt="">
          <b>انصراف</b>
        </v-btn>
        <v-btn
            outlined
            class="btn-update mr-2 "
            @click="save()"
            ref="kt_save_changes"
            :loading="loading"
            :disabled="validation"
        >
          <img src="media/svg/icons/Navigation/Waiting.svg" alt="">
          <b>به روزرسانی</b>
        </v-btn>

      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <form class="form">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <label class="col-xl-3"></label>
          <div class="col-lg-9 col-xl-6">
            <h5 class="font-weight-bold mb-6">اطلاعات شما</h5>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right"
          >تصویر پروفایل</label
          >
          <div class="col-lg-9 col-xl-6">
            <div class="image-input image-input-outline" id="kt_profile_avatar">
              <div
                  class="image-input-wrapper rounded"
              >
                <img :src="current_photo" class="rounded" alt="" width="115" height="115">
              </div>
              <label
                  class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="change"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Change avatar"
              >
                <i class="fa fa-pen icon-sm text-muted " style="color: dodgerblue !important;"></i>
                <input
                    type="file"
                    name="profile_avatar"
                    accept=".png, .jpg, .jpeg"
                    @change="onFileChange($event)"
                />
                <input type="hidden" name="profile_avatar_remove"/>
              </label>
              <span
                  class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="cancel"
                  data-toggle="tooltip"
                  title="Cancel avatar"
              >
                <i class="ki ki-bold-close icon-xs text-muted" ></i>
              </span>
              <span
                  class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="remove"
                  data-toggle="tooltip"
                  title="حذف تصویر پروفایل"
                  @click="current_photo = null"
              >
                <i class="ki ki-bold-close icon-xs text-muted" style="color: red !important;"></i>
              </span>
            </div>
            <span class="form-text text-muted"
            >انواع فایل های مجاز: png، jpg، jpeg.</span
            >
            <span class="form-text text-danger"
            >{{errors.image ? errors.image[0] : ''}}</span
            >
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right"
          >نام و نام خانوادگی</label
          >
          <div class="col-lg-9 col-xl-6">
            <v-text-field
                ref="name"
                class="form-control form-control-lg form-control-solid"
                type="text"
                dense outlined
                :error-messages="errors.name"
                v-model="name"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right">نام کاربری</label>
          <div class="col-lg-9 col-xl-6">
            <div class="spinner spinner-sm spinner-success spinner-right">
              <v-text-field
                  class="form-control form-control-lg form-control-solid"
                  type="text"
                  dense outlined
                  ref="username"
                  clearable
                  prepend-inner-icon="mdi-at"
                  :loading="loading"
                  :error-messages="errors.username"
                  v-model="username"
              />
            </div>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label class="col-xl-3 col-lg-3 col-form-label text-right">دریافت پیامک </label>
          <div class="col-lg-9 col-xl-6">
            <div class="col-3">
							<span class="switch switch-sm switch-icon pt-4">
								<label>
									<input type="checkbox" name="select"
                         v-model="notificationStatus">
                  <span></span>
								</label>
							</span>
            </div>
            <span class="form-text text-dark-50">
              با فعال کردن این گزینه هزینه ارسال پیامک ها از حساب شما کسر خواهد شد.</span>
          </div>
        </div>


        <div class="row">
          <label class="col-xl-3"></label>
          <div class="col-lg-9 col-xl-6">
            <h5 class="font-weight-bold mt-10 mb-6">اطلاعات تماس</h5>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right"
          >شماره همراه</label
          >
          <div class="col-lg-9 col-xl-6">
            <div class="input-group input-group-lg input-group-solid">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="la la-phone"></i>
                </span>
              </div>
              <input
                  ref="phone"
                  type="text"
                  class="form-control form-control-lg form-control-solid"
                  placeholder="شماره همراه"
                  readonly
                  v-bind:value="persian(phone)"
              />
            </div>

          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right"
          >ایمیل</label
          >
          <div class="col-lg-9 col-xl-6">
            <div class="input-group input-group-lg input-group-solid">

              <v-text-field
                  ref="email"
                  type="text"
                  dense outlined
                  clearable
                  :error-messages="errors.email"
                  prepend-inner-icon="mdi-email"
                  class="form-control form-control-lg form-control-solid"
                  placeholder="ایمیل"
                  v-model="email"
              />
            </div>
          <span class="form-text text-muted mt-4"
          >ما هرگز ایمیل شما را با دیگران به اشتراک نمی گذاریم.</span
          >
          </div>
        </div>

      </div>
      <!--end::Body-->
    </form>
    <!--end::Form-->
  </div>
  </v-app>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "PersonalInformation",
  data() {
    return {
      default_photo: "media/users/blank.png",
      current_photo: null,
      email: null,
      phone: null,
      username: null,
      name: null,
      image:null,
      loading: false,
      errors:[],
      notificationStatus: this.getUser().extras.notificationStatus,

    };
  },

  created() {
    this.current_photo = this.coreLandApi(this.user.image);
  },
  mounted() {
    // this.current_photo = this.currentUserPersonalInfo.photo;
    this.email = this.getUser().email;
    this.phone = this.getUser().phone;
    this.username = this.getUser().username;
    this.name = this.getUser().name;
  },
  methods: {



    save() {
      this.loading = true;
      let formData = new FormData();
      formData.append('name', this.name);
      formData.append('username', this.username)
      formData.append('email', this.email)
      if (this.image!== null)
        formData.append('image', this.image)
      formData.append('notification_status', this.notificationStatus)

      this.requestApiPost('edit/user', formData, this.configurationFile())
          .then(({data}) => {
            this.loading = false
            this.errors= [];
            // localStorage.setItem('userInfo', JSON.stringify(data.data))
            this.authority();
            this.$toast.success('پروفایل شما با موفقیت بروزرسانی شد.')

          }).catch(({response}) => {
            this.loading= false;
            this.errors = response.data.errors
      })

    },
    cancel() {
      this.$refs.name.value = this.user.name;
      this.$refs.phone.value = this.user.phone;
      this.$refs.email.value = this.user.email;
      this.$refs.username.value = this.user.username;
      this.current_photo = this.coreLandApi(this.user.image);
    },
    onFileChange(e) {
      if (this.current_photo === this.coreLandApi(this.user.image))
        this.current_photo = null
      const file = e.target.files[0];
      this.image = file

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.current_photo = event.target.result;
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    photo() {
      return this.current_photo == null
          ? this.getUser().image
          : this.current_photo;
    },
    validation() {
      return !this.name || !this.username;
    }
  }
};
</script>
